import src from "IMAGE";
export default { src, width: 720, height: 405, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAM0lEQVR42n3KOQoAQAgEQf//XC+caBaEzdSgoYMSVeWV/DEzRgTdvX8EmUkAjUZQVTvYeoZ4mbgn6PpWAAAAAElFTkSuQmCC"};
